import {all, delay, fork, put, takeLatest} from "redux-saga/effects";
import {setLoadingInvisible, setLoadingVisible} from "redux/actions";
import {
  createVendorSuccess,
  deleteVendorSuccess,
  getVendorsSuccess,
  getVendorSuccess,
  updateVendorSuccess
} from "redux/actions/Vendors";
import {VENDORS_ALL, VENDORS_CREATE, VENDORS_DELETE, VENDORS_GET, VENDORS_UPDATE} from "redux/constants/Vendors"
import AlgoliaService from "services/AlgoliaService";
import EstService from "services/EstService"

export function* getVendors() {
  yield takeLatest(VENDORS_ALL, function* ({ search, perPage, page }) {
    try {
      if (search && page === 1) {
        yield delay(1000)
      }

      const res = yield AlgoliaService.getVendors({
        query: search,
        hitsPerPage: perPage,
        page: (page - 1)
      });

      const skip = perPage * (page - 1)
      const from = skip + 1
      const to = (skip + perPage > res.data.nbHits) ? res.data.nbHits : skip + perPage
      yield put(getVendorsSuccess(res.data.hits, res.data.nbHits, from, to))
    } catch (err) {
      console.log(err)
    }
  })
}

export function* getVendor() {
  yield takeLatest(VENDORS_GET, function* ({id}) {
    try {
      const res = yield EstService.getVendor(id);
      yield put(getVendorSuccess(res.data));
    } catch (err) {
      console.log(err)
    }
  })
}

export function* createVendor() {
  yield takeLatest(VENDORS_CREATE, function* ({data, history}) {
    try {
      const res = yield EstService.createVendor(data);
      yield put(createVendorSuccess(res.data));
      history.push(`/app/vendors/${res.data.account_vendor_id}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* updateVendor() {
  yield takeLatest(VENDORS_UPDATE, function* ({id, data, history}) {
    try {
      const vendor = yield EstService.updateVendor(id, data);
      yield put(updateVendorSuccess(id, vendor.data));
      history.push(`/app/vendors/${vendor.data.account_vendor_id}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* deleteVendor() {
  yield takeLatest(VENDORS_DELETE, function* ({id, history}) {
    try {
      yield put(setLoadingVisible());
      yield EstService.deleteVendor(id);
      yield put(deleteVendorSuccess(id));
      yield put(setLoadingInvisible());
      history.push(`/app/vendors`);
    } catch (err) {
      console.log(err)
      yield put(setLoadingInvisible());
    }
  })
}

export default function* vendorsSaga() {
  yield all([
    fork(getVendors),
    fork(createVendor),
    fork(getVendor),
    fork(updateVendor),
    fork(deleteVendor),
  ]);
}